import { useEffect } from 'react';
import { NavBar } from '../components/NavBar';
import { TimeSlider } from '../components/TimeSlider';
import { PrimaryButton } from '../components/PrimaryButton';
import { useApp } from '../state/store';
import { useRoute } from '../hooks/useRoute';
import { formatMinutes, formatDuration } from '../lib/format';
import { eatTargetMax, EAT_STEP_MIN } from '../lib/timeWindow';

export function Screen2TimeWindow() {
  const origin = useApp((s) => s.origin);
  const destination = useApp((s) => s.destination);
  const eatTargetMin = useApp((s) => s.eatTargetMin);
  const setEatTarget = useApp((s) => s.setEatTarget);
  const setRoute = useApp((s) => s.setRoute);
  const setScreen = useApp((s) => s.setScreen);

  const { route, isLoading, error } = useRoute(origin, destination);

  const totalMin = route ? Math.round(route.totalDurationSec / 60) : null;
  const maxMin = totalMin === null ? null : eatTargetMax(totalMin);

  // När rutten laddats/ändrats: klampa målet till nya skalan och håll fönstret i synk.
  useEffect(() => {
    if (totalMin === null || maxMin === null) return;
    setEatTarget(Math.min(useApp.getState().eatTargetMin, maxMin), totalMin);
  }, [totalMin, maxMin, setEatTarget]);

  const canContinue = route !== null;
  const totalTravel = route ? formatDuration(route.totalDurationSec) : '—';
  const clampedTarget = maxMin === null ? 0 : Math.min(eatTargetMin, maxMin);
  const valueLabel =
    maxMin === null ? '—' : clampedTarget === 0 ? 'Så snart som möjligt' : formatMinutes(clampedTarget);

  return (
    <div className="screen screen--photo screen--time">
      <NavBar backTo={1} />
      <div className="content">
        <div className="time-card">
          <div className="time-window">
            <h2 className="time-question">När vill du äta?</h2>
            <div className="time-window-hint">
              Vi visar matställen ungefär en halvtimme före och efter tiden du väljer.
            </div>
            <div className="time-target-value">{valueLabel}</div>
            <TimeSlider
              value={clampedTarget}
              min={0}
              max={maxMin ?? EAT_STEP_MIN}
              step={EAT_STEP_MIN}
              disabled={maxMin === null}
              ariaLabel="När vill du äta"
              ariaValueText={maxMin === null ? 'Beräknar rutt' : valueLabel}
              onChange={(v) => {
                if (totalMin !== null) setEatTarget(v, totalMin);
              }}
            />
            <div className="route-total">
              {isLoading ? 'Beräknar rutt…' : `Total restid: ${totalTravel}`}
            </div>
            {error && <div className="autocomplete-error">Kunde inte hämta rutt.</div>}
          </div>

          <PrimaryButton
            disabled={!canContinue}
            onClick={() => {
              if (route) setRoute(route);
              setScreen(3);
            }}
          >
            Visa restauranger
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
